// SERVICE BUNDLES — edit this file to update the bundles shown on the website.
// Replace the bracketed placeholders with each bundle's real name, services, and details.
// Add or remove bundles freely — the page adjusts automatically.

export const BUNDLES = [
  {
    name: "Foundation",
    price: "$497 / Month",
    description: "For new and small businesses getting their compliance in order from day one. We find the gaps and build the basics.",
    items: [
      "Compliance risk assessment and gap review",
      "Core SOPs and I-9 setup",
      "Compliance checklist and document organization",
      "Notary and documentation services available as needed"
    ],
  },
  {
    name: "Growth",
    price: "$699 / Month",
    description: "For businesses hiring staff or bringing on subcontractors. We keep you compliant while you scale.",
    items: [
      "Everything in Foundation",
      "Quarterly compliance check-ins",
      "Ongoing I-9 and workforce verification support",
      "License, insurance, and subcontractor COI monitoring",
      "Preferred rates on background screening services"
    ],
  },
  {
    name: "Protection",
    price: "$1,199 / Month",
    description: "For established businesses that can't afford surprises. A full compliance partner in your corner.",
    items: [
      "Everything in Growth",
      "Annual compliance audit and audit prep",
      "Risk planning, quality policy, and custom SOPs",
      "Monthly review calls with a dedicated TSM contact",
      "Priority scheduling and best service rates"
    ],
  },
];
